import classNames from 'classnames';
import { ReactNode } from 'react';

export const Row = ({ classes, children }: { children?: ReactNode; classes?: string }) => (
  <tr className={classNames('AccordionTable-row', classes)}>{children}</tr>
);

export const SmallTable = ({ classes, children }: { children?: ReactNode; classes?: string }) => (
  <table className={classNames('AccordionTable', classes)}>
    <tbody className="AccordionTable-body">{children}</tbody>
  </table>
);
